<div class="wrapper text-center">
  <div class="title-section mb-5">{{"Dicono di noi"|translate}}</div>
  <div class="img-wrapper">
    <img src="./assets/img/sps_giornale.jpg" class="img border-green">
    <div class="box-text">      
      {{"ABOUT_US_DESCR"|translate}}
    </div>
  </div>
</div>  